module.exports = __webpack_public_path__ + "static/media/about2.a306657a.jpg";